import { gql, useMutation } from '@apollo/client'

const FORM_FRAGMENT = gql`
  fragment FormFragment on Form {
    id
    name
    beginDate
    endDate
    sector {
      id
      name
    }
    questions {
      id
      text
      dimension {
        id
        name
      }
    }
  }
`

const FORM_CREATE_QUERY = gql`
  mutation CreateForm($form: FormCreate) {
    formCreate(form: $form) {
      id
      name
      beginDate
      endDate
      sector {
        id
        name
      }
      questions {
        id
        text
        dimension {
          id
          name
        }
      }
      errors {
        message
      }
    }
  }
`

export function useFormCreateMutation(...args) {
  const [mutation, { data, ...rest }] = useMutation(FORM_CREATE_QUERY, {
    ...args,
    update(cache, { data: { formCreate } }) {
      cache.modify({
        fields: {
          formList(existing = [], { readField }) {
            const newFormRef = cache.writeFragment({
              data: formCreate,
              fragment: FORM_FRAGMENT
            })

            if (existing.results.some(ref => readField('id', ref) === formCreate.id)) {
              return existing
            } else {
              return {
                ...existing,
                results: [...existing.results, newFormRef]
              }
            }
          }
        }
      })
    }
  })

  return [
    (...args) =>
      mutation(...args).then(({ data: { formCreate }, ...rest }) => ({
        data: formCreate,
        ...rest
      })),
    {
      data: data?.formCreate,
      ...rest
    }
  ]
}
